import { FormProvider, UseFormReturn } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultTextareaField } from "../../../../common/components/forms/inputs/textareaField/DefaultTextareaField";
import { ReviewContent } from "../../../reviews/components/ReviewContent/ReviewContent";
import { IStudioReviewModel } from "../../../reviews/models/reviewModels";
import {
  IReviewReplyFormModel,
  REVIEW_REPLY_MAX_LENGTH,
} from "../models/reviewReplyFormModel";
import styles from "./ReviewReplyDialog.module.scss";

interface IReviewReplyDialogProps {
  review: IStudioReviewModel | null;
  form: UseFormReturn<IReviewReplyFormModel>;
  replyLength: number;
  isSaving: boolean;
  onSave: () => void;
  onHide: () => void;
}

/** The studio's public reply under a review; saved empty, it removes the reply. */
export const ReviewReplyDialog = ({
  review,
  form,
  replyLength,
  isSaving,
  onSave,
  onHide,
}: IReviewReplyDialogProps) => (
  <AppDialog
    header="Отговор на ревю"
    visible={!!review}
    onHide={onHide}
    className={styles.dialog}
    dismissableMask={false}
  >
    <FormProvider {...form}>
      <form
        className={styles.root}
        onSubmit={(event) => {
          event.preventDefault();
          onSave();
        }}
        noValidate
      >
        {review && (
          <ReviewContent
            review={{ ...review, ownerReply: null }}
            emptyCommentText="Без коментар"
          />
        )}

        <div className={styles.root_reply}>
          <DefaultTextareaField
            name="reply"
            label="Отговор (вижда се публично под ревюто)"
            rows={5}
            width="100%"
          />
          <span className={styles.root_reply_counter}>
            {`${replyLength}/${REVIEW_REPLY_MAX_LENGTH}`}
          </span>
        </div>

        <div className={styles.root_buttons}>
          <DefaultButton
            label="Откажи"
            design="outline"
            width="auto"
            onClick={onHide}
          />
          <DefaultButton
            label="Запази"
            type="submit"
            width="auto"
            loading={isSaving}
          />
        </div>
      </form>
    </FormProvider>
  </AppDialog>
);
